import React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import {BreadcrumbsBlock as Breadcrumbs} from "@arctheme-components/blocks/BreadcrumbsBlock/Breadcrumbs";
import { Button } from "@arctheme-components/elements/Button/Button";

const StackedLayout = ({ blocks, settings }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

  return (
    <div className="flex flex-col text-center h-full">
      {blocks.map((block, index) => {
        const commonClasses = `
          text-${block.settings.content_alignment_mobile} lg:text-${block.settings.content_alignment_desktop}
          pt-[${block.settings.padding_top_mobile}px] lg:pt-[${block.settings.padding_top_desktop}px]
          pb-[${block.settings.padding_bottom_mobile}px] lg:pb-[${block.settings.padding_bottom_desktop}px]
          pl-[${block.settings.padding_left_mobile}px] pr-[${block.settings.padding_right_mobile}px] lg:pl-[${block.settings.padding_left_desktop}px] lg:pr-[${block.settings.padding_right_desktop}px]
        `;
        
        switch (block.type) {
          case "description":

          const textStyle = isMobile
            ? block.settings.text_style_mobile
            : block.settings.text_style;

            return (
              <div
                key={index}
                className={`${textStyle} ${commonClasses}`}
              >
                <Paragraph
                  text={block.settings.text}
                  type={textStyle}
                  maxChars={block.settings.truncate_text ? 250 : 9999}
                />
              </div>
            );
          case "title":
            return (
              <div
                key={index}
                className={commonClasses}
              >
                <h1
                  className={`hidden lg:block ${block.settings.heading_type}`}
                >
                  {block.settings.title}
                </h1>
                <h1
                  className={`lg:hidden block ${block.settings.heading_type_mobile}`}
                >
                  {block.settings.title}
                </h1>
              </div>
            );
          case "tagline":
            return (
              <div
                key={index}
                className={commonClasses}
              >
                <Paragraph
                  text={block.settings.text}
                  type={`${isMobile ? block.settings.heading_type_mobile : block.settings.heading_type}`}
                />
              </div>
            );
          case "image":
            const imageUrl = isMobile
              ? block.settings.image_mobile
              : block.settings.image;

            return (
              <div
                key={index}
                className={`w-full ${commonClasses}`}
              >
                <img className="w-full" src={imageUrl} alt="" />
              </div>
            );
          case "button":
            return (
              <div
                key={index}
                className={commonClasses}
              >
                <a
                  href="#"
                  className={`button button-${block.settings.button_type}`}
                >
                  {block.settings.text}
                </a>
              </div>
            );
          case "breadcrumbs":
            return (
              <div
                key={index}
                className={commonClasses}
              >
                <Breadcrumbs
                  templateName={"page"}
                  shop={settings.shop}
                  page={settings.page}
                  request={settings.request}
                />
              </div>
            );
          case "url":
            return (
              <div 
                key={index}
                className={`url-block ${commonClasses}`}
              >
                <Button
                  reverse
                  buttonStyle={{}}
                  style="text"
                  text
                  label={block.settings.text}
                  link={block.settings.url}
                  icon="ur-arrow"
                />
              </div>
            );
          default:
            return null;
        }
      })}
    </div>
  );
};

export default StackedLayout;
